import type { BlockControlMethod } from '../BlockDefinition';

// Do not show this blocks in block picker
export const BLOCKS_TO_HIDE = ['Comment List', 'Comment Input'];

const EXPORT_BLOCK_METHOD: BlockControlMethod = {
  id: 'exportBlock' as const,
  label: 'Export Block',
  method: (block, _, __, helpers) => {
    const blockId = block?.id;
    const { onExportBlock } = helpers;

    if (blockId) {
      void onExportBlock?.(blockId);
    }

    return Promise.resolve();
  },
};

export const COMMON_BLOCK_METHODS = [EXPORT_BLOCK_METHOD];
